import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { interval, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AskServerService } from '../ask-server.service';
import { Table } from '../models/table';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

//const TableInfo: Table[] = [];
const ELEMENT_DATA: Table[] = [];

@Component({
  selector: 'app-serveur',
  templateUrl: './serveur.component.html',
  styleUrls: ['./serveur.component.scss']
})
export class ServeurComponent implements OnInit {
  actions = <any>{};
  listTable: any;
  Tables: Observable<Table[]>;
  tableCount = 0;
  countServerCall = 0;
  tableServerCall = [];
  displayedColumns: string[] = ['id', 'time', 'action'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private askServer: AskServerService,
    protected $gaService: GoogleAnalyticsService
  ) {
    iconRegistry.addSvgIcon(
      'appel-serveur',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/appel-serveur.svg')
    );
    iconRegistry.addSvgIcon(
      'eau',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/eau.svg')
    );
    iconRegistry.addSvgIcon(
      'pain',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/pain.svg')
    );
    iconRegistry.addSvgIcon(
      'sel-poivre',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/sel-poivre.svg')
    );
    iconRegistry.addSvgIcon(
      'paiement',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/paiement.svg')
    );
    iconRegistry.addSvgIcon(
      'av_timer',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/av_timer.svg')
    );
  }

  ngOnInit(): void {
    moment.updateLocale('fr', {
      relativeTime: {
        mm: '%d min',
        s: '%d sec',
        m: '%d min',
        h: '%d heure',
        d: '%d jour',
        M: '%d mois',
        y: '%d année'
      }
    });

    this.askServer.recupTables();
    this.askServer.getActions();
    this.askServer.getActionsByTable();

    this.askServer.actionsByTable.subscribe((actions: any) => {
      if (actions.length >= 0) {
        this.listTable = actions.map(item => {
          var temp = Object.assign({}, item);
          temp.actions = JSON.parse(item.actions);
          moment.relativeTimeThreshold('s', 0);

          temp = this.updateTime(temp);
          return temp;
        });

        this.askServer.getActions(); // Affichage dynamique des actions lorsqu'un appel est fait

        this.dataSource = new MatTableDataSource(this.listTable);
        this.tableCount = this.listTable.length;
        this.dataSource.sort = this.sort;
      } else {
        this.tableCount = 0;
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
      }
    });

    setInterval(() => {
      this.listTable = this.listTable.map(item => {
        var temp = this.updateTime(item);
        return temp;
      });
      this.dataSource = new MatTableDataSource(this.listTable);
    }, 1000);

    this.askServer.actions.subscribe((actions: any) => {
      this.actions = [];
      console.log(actions);
      for (const actionInfo of actions) {
        this.actions[actionInfo.action] = actionInfo.count;
      }
    });

    const refreshtime = interval(30000).pipe(
      takeWhile(() => {
        return true;
      })
    );

    refreshtime.subscribe(x => this.askServer.recupTables());
    this.$gaService.pageView('/serveur/', 'Page des serveurs');
  }

  public orderDelivered(idTable: number, actionName: string) {
    this.askServer.appelServeur(idTable, actionName);
  }

  public supprTable(idTable: any) {
    this.askServer.supprTable(idTable);
  }

  public deleteTable(tableId: any) {
    this.supprTable(tableId);
    this.$gaService.event('Clic', 'Page serveur', 'Tout supprimer');
    // this.dataSource.data.splice(i,1);
    // this.dataSource = new MatTableDataSource<Table>(this.dataSource.data);
  }

  public deleteAction(actionId: number, actionName: string) {
    this.askServer.appelServeur(actionId, actionName);
    this.askServer.getActionsByTable();
    this.askServer.getActions();
    this.$gaService.event('Clic', 'Page serveur', actionName);
  }
  public updateTime(item) {
    var temp = Object.assign({}, item);
    const time = item.time;
    const fromNow = moment(time).fromNow(true);
    temp.fromNow = fromNow;

    var fiveMinuteAgo = moment().subtract(5, 'm');
    var tenMinuteAgo = moment().subtract(10, 'm');

    const isFiveMinutesAgo = moment(item.time).isAfter(fiveMinuteAgo);
    const isMoreFiveMinutes = moment(item.time).isBefore(fiveMinuteAgo);

    const isTenMinutesAgo = moment(item.time).isAfter(tenMinuteAgo);
    const isMoreTenMinutes = moment(item.time).isBefore(tenMinuteAgo);

    if (isFiveMinutesAgo) {
      temp.color = '#1fd345';
    } else if (isMoreFiveMinutes && isTenMinutesAgo) {
      temp.color = '#ef8d02';
    } else if (isMoreTenMinutes) {
      temp.color = '#f6150a';
    }
    return temp;
  }
}
